import { delay } from 'rambdax';

// Will attempt to clear the storage 50 times, with a delay of 100ms between attempts,
// if the storage is not cleared after 5 seconds, it will log an error and break the loop.
const MAX_ATTEMPTS = 50;
const DELAY_MS = 100;

export const clearSessionStorage = async () => {
  let attempts = 0;
  let itemCount = sessionStorage.length;
  while (itemCount > 0) {
    sessionStorage.clear();
    await delay(DELAY_MS);
    itemCount = sessionStorage.length;
    attempts++;
    if (attempts >= MAX_ATTEMPTS) {
      console.error('Failed to clear session storage');
      break;
    }
  }
};

export const clearLocalStorage = async () => {
  let attempts = 0;
  let itemCount = localStorage.length;
  while (itemCount > 0) {
    localStorage.clear();
    await delay(DELAY_MS);
    itemCount = localStorage.length;
    attempts++;
    if (attempts >= MAX_ATTEMPTS) {
      console.error('Failed to clear local storage');
      break;
    }
  }
};
